import { render, staticRenderFns } from "./GroupMainPage.vue?vue&type=template&id=14caaf30&scoped=true&"
import script from "./GroupMainPage.vue?vue&type=script&lang=js&"
export * from "./GroupMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14caaf30",
  null
  
)

export default component.exports